var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing__risks"},[_c('h4',[_vm._v(" "+_vm._s(_vm.$t('landing.risks.investmentRisks'))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('landing.risks.generalRisksAssociated'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }